<template>
<div>
    <b-card class="modal-task">
    <div v-for="(task, index) in allItems" :key="index">
        <div class="row set_goal_list" v-if="Object.keys(task.goal).length == 0">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="task-title">
                    <span class="counter_task-list__counter"></span>
                    {{ task.description }}
                </div>
            </div>
        </div>
        <div v-else>
            <div class="webview">
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <div class="task-title">
                        <span class="counter_task-list__counter"></span>
                        {{ task.description }}
                        </div>
                    </div>
                    <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                    <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text">{{ calchoursonly(task.goal.task_hours) + '/' + task.goal.goal_hours + ' Task Hours' }}</div>
                    <div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text">{{ task.goal.completion_date }} </div>
                </div>
            </div>
            <div class="mobileview">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12">
                        <div class="task-title">
                        <span class="counter_task-list__counter"></span>
                        {{ task.description }}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3 col-sm-3 col-md-3 task_goal_text">
                        
                    </div>
                    <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                    <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ calchoursonly(task.goal.task_hours) + '/' + task.goal.goal_hours + ' Task Hours' }}</div>
                    <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ task.goal.completion_date }} </div>
                </div>
            </div>
        </div>
    </div>
    <div class="progress_section col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6">
        <div class="row mb-3">
        <div class="col-3">{{ progress.allTotalTaskReps + '/' + progress.allTotalGoalReps }} Reps</div>
        <div class="progress col-7 p-0" style="height: 20px;">
            <div class="progress-bar" :style="'width: ' + progress.totalRepsPercentage + '%;'" :aria-valuenow="progress.totalRepsPercentage" aria-valuemin="0" aria-valuemax="100"></div>
        </div>  
        <div :class="'col-2 ' + getPercentageClass(progress.totalRepsPercentage)">
            {{ progress.totalRepsPercentage + '%' }}
        </div>
        </div>
        <div class="row mb-3">
        <div class="col-3">{{ progress.allTotalTaskHours + '/' + progress.allTotalGoalHours }} Task Hours</div>
        <div class="progress col-7 p-0" style="height: 20px;">
            <div class="progress-bar" :style="'width: ' + progress.totalHoursPercentage + '%;'" :aria-valuenow="progress.totalHoursPercentage" aria-valuemin="0" aria-valuemax="100"></div>
        </div>  
        <div :class="'col-2 ' + getPercentageClass(progress.totalHoursPercentage)">
            {{ progress.totalHoursPercentage + '%' }}
        </div>
        </div>
    </div>
    </b-card>
</div>
</template>
<script>

export default {
    props: ['allItems', 'itemLength', 'menteeId', 'tasklistId', 'subTaskId', 'headingId', 'progress'],
    data() {
        return {
            isGoalModal: false,
            isRepsModalVisible: false,
            modalTitle: '',
            completionDate: '',
            hours: '',
            repCount: '',
            taskHours: '',
            taskRepCount: '',
            goalId: '',
            submitValue: '',
            taskGoal: [],
            subtask_id: '',
        }
    },
    components: {
    },
    methods: {
        calchoursonly: function(minutes) {
            var hours = (minutes / 60);
            var rhours = Math.floor(hours);
            var min = (hours - rhours) * 60;
            var rminutes = Math.round(min);
            if(rminutes > 0) {
                return rhours + " hr. " + rminutes + " min ";
            }
            else {
                return rhours + " hr. ";
            }
        },
        openAddRepetitionModal(args) {
            this.subtask_id = args.parentHeadingId;
            this.isRepsModalVisible = true;
            const vmessage = 'hide_vmessage';
            this.$refs.add_reps_form.getScoreLists(args, vmessage);
        },
        openModal(args, formType) {
            this.isGoalModal = true;
            const vmessage = 'hide_vmessage';
            this.$refs.add_goal_form.getTaskItem(args, vmessage);
            if (formType == "edit") {
                this.modalTitle = "Edit Goals";
                this.submitValue = "Save";
            } else {
                this.modalTitle = "Add Goals";
                this.submitValue = "Set Goals";
            }
        },
        getPercentageClass(percent) {
            return (percent > 100) ? 'red-text' : '';
        }
    }
}
</script>
<style scoped>
.dbAddRepsBtn, .dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 10px;
  width: 100%;
}
.task_goal_text {
  color:#00acee;
  text-align: left;
}
.task-title { padding: 0px; color: #7d7d7d; }
.set_goal_list { padding: 10px; }
.progress_section {
    padding: 10px;
    color: #7d7d7d;
    font-weight: 900;
}
.progress {
    border: 1px solid #00ACEE;
    background-color: #FFFFFF;
}
.progress-bar {
    background-color: #00ACEE;
}
.red-text { color: #FF0000; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .webview { display: none; }
  .mobileview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 10px; }
}
/* Medium Devices */
@media (min-width: 601px) and (max-width: 768px) { 
  .webview { display: none; }
  .mobileview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 10px; }
}
/* Large Devices */
@media (min-width: 809px) and (max-width: 1024px) { 
  .mobileview { display: none; }
  .webview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 5px; }
   .card-body { 
        font-size: 13px;
        font-weight: 500;
        margin-left: 1.5rem;
        margin-right: 1rem; 
    }
}
/* Extra Large Devices */
@media (min-width: 1200px) {
  .mobileview { display: none; }
  .webview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 5px; }
  .card-body { 
        font-size: 13px;
        font-weight: 500;
        margin-left: 1.5rem;
        margin-right: 1rem; 
    }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/mentee_goal_task_list.vue